import type { IconSetDefinitions } from '@hotjar/hotsauce/build/components/Icon/icons';

export const transformBrowserNameToIcon = (browser: string): keyof IconSetDefinitions => {
  if (!browser) {
    return 'unknown';
  }
  const browserLowerCase = browser.toLowerCase();
  if (browserLowerCase.indexOf('ie') > -1) {
    return 'ms_ie';
  }
  if (browserLowerCase.indexOf('android') > -1) {
    return 'android';
  }
  if (browserLowerCase.indexOf('chrome') > -1) {
    return 'chrome';
  }
  if (browserLowerCase.indexOf('chromium') > -1) {
    return 'chromium';
  }
  if (browserLowerCase.indexOf('blackberry') > -1) {
    return 'blackberry';
  }
  if (browserLowerCase.indexOf('firefox') > -1) {
    return 'firefox';
  }
  if (browserLowerCase.indexOf('edge') > -1) {
    return 'edge';
  }
  if (browserLowerCase.indexOf('opera') > -1) {
    return 'opera';
  }
  if (browserLowerCase.indexOf('safari') > -1) {
    return 'safari';
  }
  return 'unknown';
};
